import { Canvas } from 'fabric'

import { addBsreStamp, removeBsreStamp } from './bsreStamp'
import { exportObjectToSVG } from './exportSVG'
import { getSVGStringFromUrl, loadSVGStringIntoCanvas } from './canvas'
import { getGuruToken } from 'src/helpers/session'

export const svgHasContent = (svgUrl?: string | null): boolean => {
  return !!svgUrl && svgUrl.trim().length > 0
}

const withOffscreenCanvas = async (
  svgUrl: string,
  manipulate: (canvas: Canvas) => Promise<void> | void,
): Promise<{ svgBlob: Blob; usedSystemVariables: string[] }> => {
  const el = document.createElement('canvas')
  el.style.display = 'none'
  document.body.appendChild(el)

  const canvas = new Canvas(el, { width: 1123, height: 794 })

  try {
    const svgString = await getSVGStringFromUrl(svgUrl, undefined)

    await loadSVGStringIntoCanvas(svgString, canvas)

    await manipulate(canvas)

    const object = await canvas.toObject([
      'customId',
      'customVariableKey',
      'customObjectType',
      'customObjectWidth',
      'selectable',
      'evented',
      'lockMovementX',
      'lockMovementY',
      'lockRotation',
      'lockScalingX',
      'lockScalingY',
      'lockScalingFlip',
      'hasControls',
      'hasBorders',
    ])

    const { svgString: newSvgString, usedSystemVariables } =
      await exportObjectToSVG(object)

    return {
      svgBlob: new Blob([newSvgString], { type: 'image/svg+xml' }),
      usedSystemVariables,
    }
  } finally {
    canvas.dispose()
    el.remove()
  }
}

export const injectBsreStampIntoSVG = async (svgUrl: string) => {
  return withOffscreenCanvas(svgUrl, async (canvas) => {
    await addBsreStamp(canvas)
  })
}

export const removeBsreStampFromSVG = async (svgUrl: string) => {
  return withOffscreenCanvas(svgUrl, (canvas) => {
    removeBsreStamp(canvas)
  })
}

export const saveTemplateSVG = async (
  programId: string,
  templateId: string,
  page: 'front' | 'back',
  svgBlob: Blob,
  usedSystemVariables: string[],
  kapabilitas: string = 'instruktur',
) => {
  const formData = new FormData()
  formData.append('page', page)
  formData.append(
    'template',
    svgBlob,
    `${programId}_${templateId}_${kapabilitas}_${page}_template.svg`,
  )

  usedSystemVariables.forEach((item) => {
    formData.append('usedSystemVariables', item)
  })

  const token = getGuruToken()
  const res = await fetch(
    `${process.env.NEXT_PUBLIC_LMS_API_URL}/programs/${programId}/certificate-templates/${templateId}`,
    {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${token}`,
      },
      body: formData,
    },
  )

  if (!res.ok) {
    throw new Error('Failed to save template SVG')
  }
}
